import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  text: {
    fontSize: '20px !important',
    fontWeight: '700'
  }
}))
